import { render, staticRenderFns } from "./DirtyRecords.vue?vue&type=template&id=aef61458"
import script from "./DirtyRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./DirtyRecords.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports